import loadable from "@loadable/component";
import { useEffect, useRef, useState } from "react";
import { ArticleType } from "@shared/url";

const ArticleCarousel = loadable(
  () => import(/* webpackChunkName: "article-carousel" */ "./article-carousel"),
  { ssr: false }
);

type Props = {
  type: ArticleType;
};

/**
 * The carousel fetches its content client-side and is below the initial viewport.
 * Keep it out of the SSR/hydration critical path, then enhance it shortly before
 * the visitor reaches its reserved location.
 */
const DeferredArticleCarousel = ({ type }: Props) => {
  const targetRef = useRef<HTMLDivElement>(null);
  const [ shouldLoad, setShouldLoad ] = useState(false);

  useEffect(() => {
    const target = targetRef.current;
    if (!target) return;

    const observer = new IntersectionObserver(([ entry ]) => {
      if (!entry.isIntersecting) return;

      setShouldLoad(true);
      observer.disconnect();
    }, { rootMargin: "300px 0px" });

    observer.observe(target);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={targetRef} className="article-carousel-deferred">
      {shouldLoad && <ArticleCarousel type={type} />}
    </div>
  );
};

export default DeferredArticleCarousel;
